import React from 'react'
import CognitoUserManagement from './CognitoUserManagement'

import FormatCheckTextBox from '../../../../common/component/FormatCheckTextBox'
import Window from '../../../../common/Window'

class CognitoUserEdit extends CognitoUserManagement {
  getInitialState () {
    return {
      isNew: true,
      enabled: '',
      createdDateTime: '',
      updatedDateTime: '',
      status: '',
      id: '',
      email: '',
      name: '',
      emailNotification: 'true',
      prefectures: '',
      branch: '',
      administrator: '',
      isMember: 'true',
      parentID: ''
    }
  }
  changed (name, e) {
    this.setState({[name]: e.target.value})
  }
  loadUserDetail (id) {
    const onSuccess = (cognitoUser) => {
      this.setState({
        isNew: false,
        isLoaded: true,
        enabled: cognitoUser.Enabled,
        createdDateTime: cognitoUser.UserCreateDate,
        updatedDateTime: cognitoUser.UserLastModifiedDate,
        status: cognitoUser.UserStatus,
        id: cognitoUser.Username,
        email: this.arrayGet(cognitoUser.UserAttributes, 'email'),
        name: this.arrayGet(cognitoUser.UserAttributes, 'custom:Name'),
        emailNotification: this.arrayGet(cognitoUser.UserAttributes, 'custom:emailNotification'),
        prefectures: this.arrayGet(cognitoUser.UserAttributes, 'custom:prefectures'),
        branch: this.arrayGet(cognitoUser.UserAttributes, 'custom:branch'),
        administrator: this.arrayGet(cognitoUser.UserAttributes, 'custom:administrator'),
        isMember: this.arrayGet(cognitoUser.UserAttributes, 'custom:isMember'),
        parentID: this.arrayGet(cognitoUser.UserAttributes, 'custom:ParentID')
      })
    }
    this.getCognitoUser(id, onSuccess)
  }
  renderUserDetail (title, nameTitle, userDetail, isNew) {
    const actionTitle = isNew ? '新規登録' : '変更'
    const emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/
    if(this.userRoleUrl == 'company_user') {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>メールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true' || userDetail.emailNotification === 'True'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false' || userDetail.emailNotification === 'False'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    } else {
      return (
        <fieldset>
          <legend>{title} - {actionTitle}</legend><br />
          <div className='control-group'><label className='control-label'>{nameTitle} <span className='required'>*</span></label>
            <div className='controls'><input type='text' name='name' className='span5' value={userDetail.name} autoComplete='false' onChange={e => this.changed('name', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>会社所在地都道府県名</label>
            <div className='controls'><input type='text' name='prefectures' className='span5' value={userDetail.prefectures} autoComplete='false' onChange={e => this.changed('prefectures', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>支部名</label>
            <div className='controls'><input type='text' name='branch' className='span5' value={userDetail.branch} autoComplete='false' onChange={e => this.changed('branch', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者名</label>
            <div className='controls'><input type='text' name='administrator' className='span5' value={userDetail.administrator} autoComplete='false' onChange={e => this.changed('administrator', e)} /></div>
          </div>
          <div className='control-group'><label className='control-label'>企業管理者メールアドレス <span className='required'>*</span></label>
            <div className='controls'>
              <FormatCheckTextBox className='span5' value={userDetail.email} autoComplete='false' onChange={e => this.changed('email', e)} pattern={emailPattern} message='正しいメールアドレスの形式で入力してください' />
            </div>
          </div>
          <div className='control-group'>
            <label className='control-label'>お知らせメール受信 <span className='required'>*</span></label>
            <div className='controls kw-radio'>
              <label htmlFor='Recieve' className='kw-pointer'><input type='radio' id='Recieve' name='RecieveType' checked={userDetail.emailNotification === 'true' || userDetail.emailNotification === 'True'} value='true' onChange={e => this.changed('emailNotification', e)} />受信する</label>
              <label htmlFor='NonRecieve' className='kw-pointer'><input type='radio' id='NonRecieve' name='RecieveType' checked={userDetail.emailNotification === 'false' || userDetail.emailNotification === 'False'} value='false' onChange={e => this.changed('emailNotification', e)} />受信しない</label>
            </div>
          </div>
        </fieldset>
      )
    }
  }
  addUser (newUser) {
    newUser.name = newUser.name.trim()
    newUser.email = newUser.email.trim()
    if (newUser.name === '') {
      Window.alert(this.nameTitle + 'は必須です。')
      return false
    }
    if (newUser.email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    const onSuccess = (res) => {
      if (res.body.isOK) {
        //console.log(res.body)  //デバッグ時以外はコメントアウト
        Window.alert(this.userRoleName + '情報を登録しました', () => {
          let detailUrl = '/company_admin/' + this.userRoleUrl + '/detail/' + res.body.data.User.Username + '?temporaryPassword=' + res.body.data.temporaryPassword
          if (this.parentUserRoleUrl) {
            const {params} = this.props.match
            const parentID = params.parentID
            detailUrl = '/company_admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + res.body.data.User.Username + '?temporaryPassword=' + res.body.data.temporaryPassword
          }
          this.props.history.push(detailUrl)
          Window.closeDialog()
        })
      } else {
        if (res.body.message == 'An account with the email already exists.') {
          Window.alert('既に存在するメールアドレスです。')
          return false
        }
        //console.log(res) //デバッグ時以外はコメントアウト
        Window.alert('登録時にエラーが発生しました')
      }
    }
    this.addCognitoUser(newUser, onSuccess)
  }
  updateUser (updateUser, detailUrl) {
    updateUser.name = updateUser.name.trim()
    updateUser.email = updateUser.email.trim()
    if (updateUser.name === '') {
      Window.alert(this.nameTitle + 'は必須です。')
      return false
    }
    if (updateUser.email === '') {
      Window.alert('メールアドレスは必須です。')
      return false
    }
    const onSuccess = (res) => {
      if (res.body && res.body.data && !res.body.data.hasOwnProperty('code')) {
        Window.alert(this.userRoleName + '情報を更新しました', () => {
          this.props.history.push(detailUrl)
          Window.closeDialog()
        })
      } else {
        console.log(res)  //デバッグ時以外はコメントアウト
        Window.alert('更新時にエラーが発生しました')
      }
    }
    this.updateCognitoUser(updateUser, onSuccess)
  }
  onPageMenuClicked (name) {
    const id = this.state.id

    let backUrl
    if (this.state.isNew) {
      backUrl = '/company_admin/' + this.userRoleUrl + '/'
    } else {
      backUrl = '/company_admin/' + this.userRoleUrl + '/detail/' + id
    }

    if (this.parentUserRoleUrl) {
      const {params} = this.props.match
      const parentID = params.parentID
      if (this.state.isNew) {
        backUrl = '/company_admin/' + this.parentUserRoleUrl + '/detail/' + parentID
      } else {
        backUrl = '/company_admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + id
      }
    }

    switch (name) {
      case 'back':
        this.props.history.push(backUrl)
        break
      default:
        break
    }
  }
  onFormButtonClicked (name, e) {
    e.preventDefault()
    const adminUser = this.state
    let backUrl
    if (this.state.isNew) {
      backUrl = '/company_admin/' + this.userRoleUrl + '/'
    } else {
      backUrl = '/company_admin/' + this.userRoleUrl + '/detail/' + adminUser.id
    }

    if (this.parentUserRoleUrl) {
      const {params} = this.props.match
      const parentID = params.parentID
      if (this.state.isNew) {
        backUrl = '/company_admin/' + this.parentUserRoleUrl + '/detail/' + parentID
      } else {
        backUrl = '/company_admin/' + this.userRoleUrl + '/detail/' + parentID + '/' + adminUser.id
      }
    }
    switch (name) {
      case 'save':
        if (this.state.isNew) {
          const {params} = this.props.match
          if (params.parentID) {
            const parentID = params.parentID
            adminUser.parentID = parentID
          }
          this.addUser(adminUser)
        } else {
          this.updateUser(adminUser, backUrl)
        }
        break
      case 'cancel':
        // console.log(backUrl)  //デバッグ時以外はコメントアウト
        this.props.history.push(backUrl)
        break
      default:
        break
    }
  }
  render () {
    const userDetail = this.renderUserDetail(this.userRoleName + '情報', this.nameTitle, this.state, this.state.isNew)
    const title = this.state.isNew ? '新規登録' : '変更'
    return (
      <div>
        <section className='nav-page'>
          <div className='container'>
            <div className='row'>
              <div className='span7'>
                <header className='page-header'>
                  <h3>{this.userRoleName}情報 - {title}<br /><small>こちらで{this.userRoleName}の情報を{title}できます。</small></h3>
                </header>
              </div>
              <div className='span9'>
                <ul className='nav nav-pills'>
                  <li className='kw-btn-area'><button rel='tooltip' data-placement='left' title='戻る' className='text-center kw-btn-primary' onClick={(e) => this.onPageMenuClicked('back')}><i className='icon-arrow-left icon-large' /><span>戻る</span></button></li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section className='page container'>
          <form className='form-horizontal' method='post'>
            <div className='alert alert-block alert-info'>
              <p>必要な情報を入力して最後に「保存」ボタンを押してください。「<span className='required'>*</span>」マークは必須項目です。</p>
            </div>
            {userDetail}
            <footer id='submit-actions' className='form-actions'>
              <button className='btn btn-primary' onClick={(e) => this.onFormButtonClicked('save', e)} >保存</button>
              <button className='btn btn-default' onClick={(e) => this.onFormButtonClicked('cancel', e)}>キャンセル</button>
            </footer>
          </form>
        </section>
      </div>
    )
  }
}

export default CognitoUserEdit



// WEBPACK FOOTER //
// ./src/company_admin/pages/secure/abstract/CognitoUserEdit.js